// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"71c1b9e3","936":"a8bb110f"}[chunkId] + ".css";
};